export default {
  isSyncing: false, // 同步锁
  curDocument: {}, // 同步锁
  isSelectAll: false, // 是否全选了
  markdownLock: false, // markdown语法锁
  curCursorIndex: 0, // 当前光标位置
  curWrapType: '', // 两个\n（换行）在一起的情况种类
  chineseLock: false, // 中文锁
  curSelectLength: 1, // 当前选中的字符串的长度
  curContentCopy: [], // 编辑器某一次操作的副本
  historyContentCopy: [], // 编辑器当前所有历史操作（不包括本次）的副本
  curCacheOps: [], // 当前缓存操作集合，是个二维数组
  syncMessageCache: [], // 输入中文期间受到的消息会被缓存在这里，是个三维数组，也就是changeData的一个集合
  curOpsDelta: [], // 当前操作
  cacheLock: false, // 缓存锁
  operationNum: 0, // 本地自己的操作次数
  receiveOperationQueue: [], // 在输入中文的时候记录收到的别人的消息
  ownOperationQueue: [], // 自己发送过并且还未从服务器返回来的消息，此队列或许会影响收到的别人的消息
  imApiDomain: ''
}



// WEBPACK FOOTER //
// ./src/common/store/state.js